<div class="flex flex-col pt-2">
	<app-file-upload
		label="Upload documents"
		type="dropzone"
		(fileSelected)="fileSelected($event)"
		[multiple]="true"
		[fileTypes]="FILE_PACKAGE_TYPES"
		*ngIf="!replacingDocument"
	></app-file-upload>
	<div class="px-6 mb-3" *ngIf="replacingDocument">
		<h4>Upload a new version of the following document</h4>
		<div
			class="flex p-1 items-center px-2 border-gray-200 border rounded-lg w-full"
		>
			<app-icon [icon]="ICON.FILE" class="mr-3"></app-icon>
			<div>
				<p class="text-sm text-grey">
					{{ mortgageSupTypeStrings[subType] | uppercase }}
				</p>
				<p>{{ replacingDocument.name }}</p>
			</div>
		</div>
		<app-file-upload
			(fileSelected)="fileSelected($event)"
			[multiple]="false"
			type="dropzone"
			*ngIf="!files.length"
			[fileTypes]="FILE_PACKAGE_TYPES"
		></app-file-upload>
	</div>
	<div *ngIf="files.length > 0" class="px-6 py-4 -mt-3">
		<p class="font-bold mb-2">Selected files</p>
		<div class="border rounded-xl p-2">
			<table class="w-full table-fixed">
				<thead>
					<tr class="text-left">
						<th class="w-9"></th>
						<th>File name</th>
						<th *ngIf="!lockFileType || showSubTypes">Category type</th>
						<th class="w-9"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let file of files">
						<td class="px-1">
							<app-icon
								class="text-2xl text-green"
								[icon]="ICON.FILE"
								*ngIf="!file.fileUploadStatus"
							></app-icon>
							<app-icon
								class="text-2xl text-green"
								[icon]="ICON.LOADING"
								[spin]="true"
								*ngIf="
									file.fileUploadStatus?.status === fileUploadStatuses.UPLOADING
								"
							></app-icon>
							<app-icon
								class="text-2xl text-green"
								[icon]="ICON.CHECK"
								*ngIf="
									file.fileUploadStatus?.status === fileUploadStatuses.SUCCESS
								"
							></app-icon>
							<app-icon
								class="text-2xl text-red"
								[icon]="ICON.TIMES"
								*ngIf="
									file.fileUploadStatus?.status === fileUploadStatuses.FAILED
								"
							></app-icon>
						</td>
						<td class="px-1">
							<app-input
								*ngIf="
									file.fileUploadStatus?.status !== fileUploadStatuses.SUCCESS
								"
								class="text-lg"
								placeholder="file name"
								[(ngModel)]="file.fileName"
								(debounce)="updateFileName(file?.fileId, $event)"
								required
							></app-input>
							<div
								*ngIf="
									file.fileUploadStatus?.status === fileUploadStatuses.SUCCESS
								"
								class="text-lg"
							>
								{{ file.fileName }}
							</div>
						</td>
						<td class="px-1" *ngIf="!lockFileType">
							<app-select
								*ngIf="
									file.fileUploadStatus?.status !== fileUploadStatuses.SUCCESS
								"
								[ngModel]="file.fileType"
								(ngModelChange)="updateFileType(file.fileId, $event)"
								[testHook]="testHooks.UpdateFileTypeSelect"
							>
								<option
									*ngFor="let type of fileTypes"
									[value]="type.type"
									[testHook]="testHooks.FileTypeOption"
								>
									{{ type.friendlyType }}
								</option>
							</app-select>
							<div
								*ngIf="
									file.fileUploadStatus?.status === fileUploadStatuses.SUCCESS
								"
								class="text-lg"
							>
								{{ file.friendlyType }}
							</div>
						</td>
						<td class="px-1" *ngIf="showSubTypes && !replacingDocument">
							<app-select
								*ngIf="
									file.fileUploadStatus?.status !== fileUploadStatuses.SUCCESS
								"
								[ngModel]="file.subType"
								(ngModelChange)="updateSubType(file.fileId, $event)"
								[testHook]="testHooks.UpdateSubTypeSelect"
							>
								<option
									*ngFor="let type of subTypes"
									[value]="type.type"
									[testHook]="testHooks.SubTypeOption"
								>
									{{ type.friendlyType }}
								</option>
							</app-select>
							<div
								*ngIf="
									file.fileUploadStatus?.status === fileUploadStatuses.SUCCESS
								"
								class="text-lg"
							>
								{{ file.friendlySubType }}
							</div>
						</td>
						<td class="px-1">
							<app-icon
								class="cursor-pointer"
								*ngIf="
									file.fileUploadStatus?.status !== fileUploadStatuses.SUCCESS
								"
								(click)="remove(file.fileId)"
								[icon]="ICON.REMOVE"
								[testHook]="testHooks.RemoveIcon"
							></app-icon>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
<div class="px-6 pb-8">
	<div class="mt-5" *ngIf="failedUploading">
		One or more files didn't upload successfully
	</div>

	<app-button
		class="mt-3"
		(onClick)="close()"
		btn="border"
		*ngIf="files.length === 0"
		>Close</app-button
	>

	<div
		class="flex justify-between flex-1 mt-10 max-h-24"
		*ngIf="files.length > 0"
	>
		<app-button (onClick)="close()" btn="border">Close</app-button>
		<app-button (onClick)="upload()" [disabled]="disableUpload"
			>Upload</app-button
		>
	</div>
</div>
